import { useCallback } from 'react'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { ButtonsModalSmallCentered, ModalSmallCentered } from '../../../../../../../../baseComponents/Modal'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { RemittanceDataTy } from '../../Remittances/ModalNewRemittance/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import useIsLoading from '../../../../../../../../utils/hooks/useIsLoading'
import { getSelectedIdsRemittanceMarkAsPaid } from './functions'
import { payMCopyDateStatusInversed } from '@teinor/erp/types/company/accounting/payMCopy/payMCopyDate'
import { ModalEditComponentPropsWithoutSubmit } from '../../../../../../../../baseComponents/ModalsLayouts/types'

type ModalConfirmRemittancesMarkAsPaidProps = ModalConfirmRemittancesMarkAsPaidLogicProps & ModalEditComponentPropsWithoutSubmit & {}

const ModalConfirmRemittancesMarkAsPaid: React.FC<ModalConfirmRemittancesMarkAsPaidProps> = ({ setOpened, completeData, onSubmit }) => {
    const {t} = useTwinTranslation()
    const { loading, createRemittance } = useModalConfirmRemittancesMarkAsPaidLogic({ completeData, onSubmit })
    return (
        <ModalSmallCentered opened={true} setOpened={setOpened}>
            <h2><TwinTrans transKey='markAsPaid'>Marcar como pagado</TwinTrans></h2>
            <span> <TwinTrans transKey='sureMarkAsPaid'>¿Seguro que quieres marcar como pagados?</TwinTrans></span>
            <ButtonsModalSmallCentered loading={loading} confirmText={t('accept', 'Aceptar')} setOpened={() => setOpened(null)} onAccept={createRemittance}></ButtonsModalSmallCentered>
        </ ModalSmallCentered>
    )
}

interface ModalConfirmRemittancesMarkAsPaidLogicProps {
    completeData: RemittanceDataTy
    onSubmit?: OnSubmit
}

const useModalConfirmRemittancesMarkAsPaidLogic = ({ completeData, onSubmit }: ModalConfirmRemittancesMarkAsPaidLogicProps) => {
    const { loading, startLoading, endLoading } = useIsLoading()

    const createRemittance = useCallback(async () => {
        startLoading()
        const selectedIds = getSelectedIdsRemittanceMarkAsPaid(completeData)
        const result = await twinFetchPostJSON('/api/app/config/payment/paymentMethod/changeStatusPaymentMethodCopyDates', { selectedIds, status: payMCopyDateStatusInversed['payed']})
        onSubmit?.(result, {})
        endLoading()
    }, [completeData, startLoading, endLoading, onSubmit])

    return { loading, createRemittance }
}

export default ModalConfirmRemittancesMarkAsPaid